import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PopupService} from "../../../../services/popup.service";

@Component({
  selector: 'app-google',
  templateUrl: './google.component.html',
  styleUrls: ['./google.component.scss']
})
export class GoogleComponent {
  constructor(
    private routerService: Router,
    private popupService: PopupService,
    private route: ActivatedRoute

  ) {}
  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.popupService.error('Connection Failed',params['error'],'OK');
      }
      else {
        this.popupService.success("", "Google Connected Successfully", 'OK');
      }

      this.routerService.navigate(['/settings/account']);

    });
  }
}
